import { useState, Fragment,createContext, useContext  } from 'react';

const ArticlesContext = createContext();

const ArtclesProvider = ({ children }) => {

const [articles, setArticles] = useState([]);
const [id, setId] = useState();



  return (
    <ArticlesContext.Provider value={{articles, setArticles, id, setId}}>
      {children}
    </ArticlesContext.Provider>
  );
  }
  export {ArticlesContext,ArtclesProvider}